import topManager from '../../page/top';

export default class videoManager{
    constructor(){

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        this.video;
        this.videoTexture;
        this.videoMesh;
        this.scene;
        this.camera;
        this.renderer;

        /* ftps低下時の対策 */
        this.time = 0;
        this.timeRatio = 1;
        this.FPS_60_SEC = 1000 / 60;
        this.count = 0;

        this.ended = false;

        this.toppage = new topManager();

        this.status = [];
        this._root = '';
        this._path = '';
        this._movie = '';

        let _url = location.href;
        if ( _url.indexOf('/jp/ja/') != -1){
            this.videosrc = '/content/dam/denso/common/language-variation/ja/innovation/technology/maas/images/opening.mp4';
            this.videosrcMov = '/content/dam/denso/common/language-variation/ja/innovation/technology/maas/images/opening.mov';
        }else{
            this.videosrc = '/content/dam/denso/global/en/innovation/technology/maas/images/opening.mp4';
            this.videosrcMov = '/content/dam/denso/global/en/innovation/technology/maas/images/opening.mov';
        }

    }

    init(_status,_root,_path){

        this.status = _status;

        //ios用
        if(Useragnt.ios){
            this.makeVideo(_status);
        }else{
            // $("#l-movie").append('<video id="l-movie-video"><source src="" type="video/mp4"><source src="" type="video/mov"></video>');
            // $("#l-movie-video source").eq(0).attr("src",this.videosrc);
            // $("#l-movie-video source").eq(1).attr("src",this.videosrcMov);

            this.video = document.getElementById("l-movie-video");

            let _this = this;
            setTimeout(function () {
                _this.video.play();
                $('body .pace').remove();
            },1e3);
            this.video.addEventListener('timeupdate', function(){
                if(_this.video.currentTime >= 3.4){
                    if(_this.ended) return false;
                    _this.toppage.movieEnd(_status,_root,_path);
                    _this.ended = true;
                }
            });

        }

        //this.render();

    }

    makeVideo(_status){

        var _this = this;

        // scene ステージ
        this.scene = new THREE.Scene();

        // camera
        this.camera = new THREE.PerspectiveCamera(50, this.w / this.h, 1, 10000);
        this.camera.updateProjectionMatrix();
        this.camera.position.z = 1000;

        this.renderer = new THREE.WebGLRenderer({
            // alpha              : true,
            antialias          : false,
            stencil            : false,
            depth              : false,
        });
        this.renderer.setSize(this.w, this.h);
        this.renderer.setClearColor(0xffffff,0);
        this.renderer.setPixelRatio(this.pixelRato);
        this.renderer.autoClear = false;
        document.getElementById('l-movie').appendChild(this.renderer.domElement);

        //このvideo要素から毎フレームキャプチャ
        this.video = document.createElement('video');
        this.video.preload = 'none';
        this.video.autoplay = false;
        this.video.loop = false;

        //src指定
        this.video.src = this.videosrc;

        //video要素からテクスチャ生成するやつ
        this.videoTexture = new THREE.VideoTexture(this.video);
        this.videoTexture.format = THREE.RGBFormat;

        //テクスチャサイズ可変する場合、ここ設定しておかないと警告でる
        this.videoTexture.minFilter = THREE.LinearFilter;
        this.videoTexture.magFilter = THREE.LinearFilter;

        this.videoTexture.needsUpdate = true;

        //動画の読み込み開始
        this.video.load();

        //テクスチャ表示するためのMesh
        let _geo = new THREE.PlaneBufferGeometry(1,1);
        let _mat =  new THREE.MeshBasicMaterial({
            map: _this.videoTexture
            // overdraw: true,
            // side:THREE.DoubleSide
        });
        this.videoMesh = new THREE.Mesh( _geo,_mat );

         //各自用意したTHREE.Sceneに追加
        this.scene.add(this.videoMesh);

        // 動画のサイズがわかったらMeshのサイズを合わせる
        this.video.addEventListener('loadeddata', (e) => {
            _this.resize();
            _this.video.play();
            _status.openingLoaded = true;
            $('body .pace').remove();
        }, false);

    }

    updateTimeRatio() {
        let _lastTime = this.time;
        if(_lastTime > 0) {
            let _dTime = new Date().getTime() - _lastTime;
            this.timeRatio = _dTime / this.FPS_60_SEC;
        }
        this.time = new Date().getTime();
    }
    render(_root,_path) {

        this.updateTimeRatio();
        this.count ++;

        if(this.count %2 === 0) return;

        if(Useragnt.ios){
            this.video.currentTime += 0.05*this.timeRatio;
            if(this.video.currentTime>=this.video.duration){
                this.toppage.movieEnd(this.status,_root,_path);
                this.ended = true;
                //this.video.currentTime = 0;
            }
            this.videoTexture.needsUpdate = true;
        }else{
            // this.video.currentTime += 0.02*this.timeRatio;
            // if(this.video.currentTime>=this.video.duration) this.video.currentTime = 0;
        }

        this.renderer.render(this.scene, this.camera);
    }

    resize() {

        //画面サイズ
        this.w = window.innerWidth;
        this.h = window.innerHeight;

        //画面にFIXするようにMeshのサイズ(scale)を変更
        let movW = this.w;
        let movH = this.video.videoHeight * (movW / this.video.videoWidth);
        if(movH < this.h){
            movH = this.h;
        }
        movW = this.video.videoWidth * (movH / this.video.videoHeight);
        this.videoMesh.scale.set(movW, movH, 1);

        //ピクセル等倍にする
        this.camera.aspect = this.w / this.h;
        this.camera.updateProjectionMatrix();
        this.camera.position.z = this.h / Math.tan(this.camera.fov * Math.PI / 360) / 2;

        //this.renderer.setPixelRatio(window.devicePixelRatio || 1);
        this.renderer.setSize(this.w, this.h, true);
        //this.renderer.clear();

    }

}